import { WebSocketClient } from '@/lib/ws/wsClient';

// esptoolのread_macは実機のリセット・書き込みモード突入を伴うため、ファームウェア書き込みと
// 同程度の余裕を見ておく(useBoardWebSerialApiIdentify.tsのROM系タイムアウトと同様の考え方)。
const QUERY_TIMEOUT_MS = 15000;

// Web Serial API側(useBoardWebSerialApiIdentify.tsのreadChipIdViaRom)と同じくROM(efuse MAC)
// から直接chip_idを読む。ファームウェアの書き込み状態に一切依存しないため、出荷後まだfoxから
// 一度も書き込んでいないボードでも取得できる。ブリッジ側は`read_chip_id`メッセージを受けると
// esptoolのread_macサブコマンドを実行し、結果を`chip_id_result`で返す(bridge/handlers/serial_device.py
// のread_blue_chip_id、bridge/connections/local/websocket.pyのhandle_read_chip_id参照)。
// 呼び出し元はモーダル(BoardSelectorAuto.tsx)と、USBボードが1台だけ検出されている場合の
// 親ツールバー(BoardToolbar.tsx)自身の自動問い合わせの2箇所がある。同じポートへ同時に
// 問い合わせが飛んだ場合、ブリッジ側のper-portロック(serial_device.pyのPORT_LOCK_TIMEOUT_S)
// が直列化するため、衝突して失敗することはない(2026-07-29確認)。
export async function queryChipIdOverBridge(port: string): Promise<number | null> {
    return new Promise((resolve) => {
        let settled = false;

        const finish = (result: number | null) => {
            if (settled) return;
            settled = true;
            clearTimeout(timeoutId);
            ws.close();
            resolve(result);
        };

        const ws = new WebSocketClient('/board', {
            preferLocalhost: true,
            autoReconnect: false,
            onOpen: () => {
                ws.send({ type: 'read_chip_id', port });
            },
            onMessage: (data) => {
                if (data.type === 'chip_id_result') {
                    const chipId = data.chip_id;
                    finish(data.success && typeof chipId === 'number' ? chipId : null);
                } else if (data.type === 'error') {
                    finish(null);
                }
            },
            onError: () => finish(null),
            onClose: () => finish(null),
        });

        const timeoutId = setTimeout(() => finish(null), QUERY_TIMEOUT_MS);
        ws.connect();
    });
}
